import { render } from "./fan1Direction.vue?vue&type=template&id=cc67b282&scoped=true"
import script from "./fan1Direction.vue?vue&type=script&lang=js"
export * from "./fan1Direction.vue?vue&type=script&lang=js"

import "./fan1Direction.vue?vue&type=style&index=0&id=cc67b282&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc67b282"]])

export default __exports__